import { createFileRoute } from "@tanstack/react-router";
import { useTicketTypeDrawerContext } from "@/utils/ticket-type-detail/ticket-type-drawer-context";
import { TicketTypeRulesSection } from "./fullRules";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/ticketTypes/$ticketTypeId/rules",
)({
	component: AdminTicketTypeRulesTab,
});

function AdminTicketTypeRulesTab() {
	const { ticketType } = useTicketTypeDrawerContext();

	return (
		<div className="px-5 pb-5">
			<TicketTypeRulesSection
				ticketType={ticketType}
				scope="platform"
				stayOnRoute
			/>
		</div>
	);
}
